/**
 *
 * Asynchronously loads the component for FeeSetup
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const FeeSetup = lazyLoad(
  () => import('./index'),
  module => module.FeeSetup,
);
